import { apiAxios } from "./api-config/axiosConfig";

export const homeApis = {
  getInspectorReports: async (inspectorId: string) => {
    try {
      const token = localStorage.getItem("LVaccessToken");

      const response = await apiAxios.get(`/report/inspector/${inspectorId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error: any) {
      console.error("Inspector Report API Error:", error);
      throw error?.response?.data || error;
    }
  },

  uploadFile: async (file: File, usedFor: string) => {
    try {
      const token = localStorage.getItem("LVaccessToken");

      const formData = new FormData();
      formData.append("file", file);
      formData.append("usedFor", usedFor);

      const response = await apiAxios.post(`/file/upload`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error: any) {
      console.error("File Upload API Error:", error);
      throw error?.response?.data || error;
    }
  },

  // 📌 Create Report
  createReport: async (payload: {
    notes: string;
    geoTag: { lat: string; lon: string; address: string };
    fileIds: string[];
  }) => {
    try {
      const token = localStorage.getItem("LVaccessToken");

      const response = await apiAxios.post(`/report/create`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error: any) {
      console.error("Create Report API Error:", error);
      throw error?.response?.data || error;
    }
  },
};
